import React from 'react'
import CourseList from '../../../../../Components/Lists/CourseList'
import { withStoreProvider } from '../../../../../Helpers/withStoreProvider'
import HomeStore from '../../../../Landing/Store/home-store'

const RelatedCourses = ({ restricted }) => {
  const { loading, loadFailed, data } = HomeStore.useContainer()

  return (
    <div
      className='relatedCourses'
      style={restricted ? { pointerEvents: 'none' } : {}}
    >
      <h1 className='sectionTitle'>Related Courses</h1>
      <CourseList
        data={data?.liveCourses || []}
        loading={loading}
        loadFailed={loadFailed}
        name={'Related Courses'}
      />
    </div>
  )
}

export default withStoreProvider([HomeStore])(RelatedCourses)
